import React from 'react';
import { ReactComponent } from 'Common/components/Icons/protective-mask.svg';

const ProtectiveMask = () => <ReactComponent className="MuiSvgIcon-root" />;

export default ProtectiveMask;
